import { createWidgetDefinition } from './widget-definition';
import { organisationSummaryTeamMembersWidget } from './organisation.summary.team.members';
import { organisationSummaryTeamBranchesWidget } from './organisation.summary.team.branches';
import { organisationSummaryTeamReferencesWidget } from './organisation.summary.team.references';
import { organisationSummaryTeamLeadersWidget } from './organisation.summary.team.leaders';
import { organisationSummaryDepartmentEmployeesWidget } from './organisation.summary.department.employees';
import { organisationSummaryDepartmentChildrenWidget } from './organisation.summary.department.children';
import { organisationSummaryDepartmentPositionsWidget } from './organisation.summary.department.positions';
import { organisationSummaryDepartmentBranchesWidget } from './organisation.summary.department.branches';
import { organisationSummaryRolePoliciesWidget } from './organisation.summary.role.policies';
import { organisationSummaryRoleGroupsWidget } from './organisation.summary.role.groups';
import { organisationRecordEmployeesWidget } from './organisation.record.employees';
import { organisationRecordBranchesWidget } from './organisation.record.branches';
import { organisationRecordLocationsWidget } from './organisation.record.locations';
import { organisationRecordSalesWidget } from './organisation.record.sales';
import { organisationRecordSalesTrendWidget } from './organisation.record.sales-trend';
import { organisationRecordHiringTrendWidget } from './organisation.record.hiring-trend';
import { organisationWelcomeWidget } from './organisation.welcome';
import { salesOrderCountWidget } from './sales.order-count';
import { salesRevenueWidget } from './sales.revenue';
import { salesSentOrdersWidget } from './sales.sent-orders';
import { peopleNewStaffWidget } from './people.new-staff';
import { salesTaxRateWidget } from './sales.tax-rate';
import { salesRevenueTrendWidget } from './sales.revenue-trend';
import { peopleStaffTrendWidget } from './people.staff-trend';
import { salesStatusListWidget } from './sales.status-list';
import { crmLeadsWidget } from './crm.leads';
import { crmOpportunitiesWidget } from './crm.opportunities';
import { crmPipelineValueWidget } from './crm.pipeline-value';
import { crmWinProbabilityWidget } from './crm.win-probability';
import { crmPipelineTrendWidget } from './crm.pipeline-trend';
import { crmStageListWidget } from './crm.stage-list';
import { crmPipelineReportWidget } from './crm.pipeline-report';
import { procurementPurchaseCountWidget } from './procurement.purchase-count';
import { procurementSpendWidget } from './procurement.spend';
import { procurementPendingReceiptsWidget } from './procurement.pending-receipts';
import { procurementSpendTrendWidget } from './procurement.spend-trend';
import { procurementOrderTrendWidget } from './procurement.order-trend';
import { procurementStatusListWidget } from './procurement.status-list';
import { procurementVendorReportWidget } from './procurement.vendor-report';
import { inventoryEventCountWidget } from './inventory.event-count';
import { inventoryUnitsMovedWidget } from './inventory.units-moved';
import { inventoryReceiptsWidget } from './inventory.receipts';
import { inventoryMovementTrendWidget } from './inventory.movement-trend';
import { inventoryValuationTrendWidget } from './inventory.valuation-trend';
import { inventoryEventTrendWidget } from './inventory.event-trend';
import { inventoryEventTypesWidget } from './inventory.event-types';
import { inventoryMovementReportWidget } from './inventory.movement-report';
import { inventoryProductsInStockWidget } from './inventory.products-in-stock';
import { salesTopProductsWidget } from './sales.top-products';
import { procurementTopProductsWidget } from './procurement.top-products';
import { financeQuarterlyRevenueProfitWidget } from './finance.quarterly-revenue-profit';
import { salesProductGrossProfitWidget } from './sales.product-gross-profit';
import { financeRecordDebitsWidget } from './finance.record.debits';
import { financeRecordCreditsWidget } from './finance.record.credits';
import { financeRecordMovementWidget } from './finance.record.movement';
import { financeRecordItemsWidget } from './finance.record.items';
import { financeRecordDebitTrendWidget } from './finance.record.debit-trend';
import { financeRecordCreditTrendWidget } from './finance.record.credit-trend';
import { financeDebitsWidget } from './finance.debits';
import { financeCreditsWidget } from './finance.credits';
import { financeProfitWidget } from './finance.profit';
import { financeOutstandingWidget } from './finance.outstanding';
import { financeProfitTrendWidget } from './finance.profit-trend';
import { financeReceivablesTrendWidget } from './finance.receivables-trend';
import { financePayablesTrendWidget } from './finance.payables-trend';
import { financeCashflowTrendWidget } from './finance.cashflow-trend';
import { financeAccountTypeListWidget } from './finance.account-type-list';
import { financePerformanceReportWidget } from './finance.performance-report';
import { financeCashflowSankeyWidget } from './finance.cashflow-sankey';
import { financeMoneyPositionWidget } from './finance.money-position';
import { financeCashPositionWidget } from './finance.cash-position';
import { financeBankAccountPositionWidget } from './finance.bank-account-position';
import { financeBankAccountMovementWidget } from './finance.bank-account-movement';
import { salesUntaxedWidget } from './sales.untaxed';
import { salesTaxAmountWidget } from './sales.tax-amount';
import { branchCashWidget } from './branch.cash';
import { branchSalesWidget } from './branch.sales';
import { branchPurchasesWidget } from './branch.purchases';
import { locationStorageCountWidget } from './location.storage-count';
import { locationEmployeeCountWidget } from './location.employee-count';
import { locationOnHandWidget } from './location.on-hand';
import { locationInventoryValueWidget } from './location.inventory-value';
import { locationValueTrendWidget } from './location.value-trend';
import { locationMovementTrendWidget } from './location.movement-trend';
import { locationStorageTypesWidget } from './location.storage-types';
import { storageBranchGrantsWidget } from './storage.branch-grants';
import { storageDetailsWidget } from './storage.details';
import { branchEmployeesWidget } from './branch.employees';
import { branchRefundsWidget } from './branch.refunds';
import { branchTerminalsWidget } from './branch.terminals';
import { expensesTotalWidget } from './expenses.total';
import { expensesClaimCountWidget } from './expenses.claim-count';
import { expensesReimbursableWidget } from './expenses.reimbursable';
import { expensesSpendTrendWidget } from './expenses.spend-trend';
import { expensesClaimTrendWidget } from './expenses.claim-trend';
import { expensesStatusListWidget } from './expenses.status-list';
import { expensesCategoryReportWidget } from './expenses.category-report';
import { subscriptionsActiveWidget } from './subscriptions.active';
import { subscriptionsRecurringRevenueWidget } from './subscriptions.recurring-revenue';
import { subscriptionsRenewalsDueWidget } from './subscriptions.renewals-due';
import { subscriptionsRevenueTrendWidget } from './subscriptions.revenue-trend';
import { subscriptionsRenewalTrendWidget } from './subscriptions.renewal-trend';
import { subscriptionsStatusListWidget } from './subscriptions.status-list';
import { subscriptionsPerformanceReportWidget } from './subscriptions.performance-report';
import { posOrderCountWidget } from './pos.order-count';
import { posSalesWidget } from './pos.sales';
import { posActiveSessionsWidget } from './pos.active-sessions';
import { posSalesTrendWidget } from './pos.sales-trend';
import { posPaymentTrendWidget } from './pos.payment-trend';
import { posStatusListWidget } from './pos.status-list';
import { posPaymentReportWidget } from './pos.payment-report';
import { rentalOrderCountWidget } from './rental.order-count';
import { rentalValueWidget } from './rental.value';
import { rentalActiveWidget } from './rental.active';
import { rentalValueTrendWidget } from './rental.value-trend';
import { rentalOrderTrendWidget } from './rental.order-trend';
import { rentalStatusListWidget } from './rental.status-list';
import { rentalStatusReportWidget } from './rental.status-report';
import { salesPerformanceReportWidget } from './sales.performance-report';

export { DASHBOARD_APP_IDS, DASHBOARD_IDS } from './apps';
export type { DashboardAppId } from './apps';
export type { DashboardWidgetConfiguration, DashboardWidgetQuery } from './widget-definition';

export const WIDGET_CONFIGURATIONS = [
  organisationSummaryTeamMembersWidget,
  organisationSummaryTeamBranchesWidget,
  organisationSummaryTeamReferencesWidget,
  organisationSummaryTeamLeadersWidget,
  organisationSummaryDepartmentEmployeesWidget,
  organisationSummaryDepartmentChildrenWidget,
  organisationSummaryDepartmentPositionsWidget,
  organisationSummaryDepartmentBranchesWidget,
  organisationSummaryRolePoliciesWidget,
  organisationSummaryRoleGroupsWidget,
  organisationRecordEmployeesWidget,
  organisationRecordBranchesWidget,
  organisationRecordLocationsWidget,
  organisationRecordSalesWidget,
  organisationRecordSalesTrendWidget,
  organisationRecordHiringTrendWidget,
  organisationWelcomeWidget,
  salesOrderCountWidget,
  salesRevenueWidget,
  salesSentOrdersWidget,
  peopleNewStaffWidget,
  salesTaxRateWidget,
  salesRevenueTrendWidget,
  peopleStaffTrendWidget,
  salesStatusListWidget,
  crmLeadsWidget,
  crmOpportunitiesWidget,
  crmPipelineValueWidget,
  crmWinProbabilityWidget,
  crmPipelineTrendWidget,
  crmStageListWidget,
  crmPipelineReportWidget,
  procurementPurchaseCountWidget,
  procurementSpendWidget,
  procurementPendingReceiptsWidget,
  procurementSpendTrendWidget,
  procurementOrderTrendWidget,
  procurementStatusListWidget,
  procurementVendorReportWidget,
  inventoryEventCountWidget,
  inventoryUnitsMovedWidget,
  inventoryReceiptsWidget,
  inventoryMovementTrendWidget,
  inventoryValuationTrendWidget,
  inventoryEventTrendWidget,
  inventoryEventTypesWidget,
  inventoryMovementReportWidget,
  inventoryProductsInStockWidget,
  salesTopProductsWidget,
  procurementTopProductsWidget,
  financeQuarterlyRevenueProfitWidget,
  salesProductGrossProfitWidget,
  financeRecordDebitsWidget,
  financeRecordCreditsWidget,
  financeRecordMovementWidget,
  financeRecordItemsWidget,
  financeRecordDebitTrendWidget,
  financeRecordCreditTrendWidget,
  financeDebitsWidget,
  financeCreditsWidget,
  financeProfitWidget,
  financeOutstandingWidget,
  financeProfitTrendWidget,
  financeReceivablesTrendWidget,
  financePayablesTrendWidget,
  financeCashflowTrendWidget,
  financeAccountTypeListWidget,
  financePerformanceReportWidget,
  financeCashflowSankeyWidget,
  financeMoneyPositionWidget,
  financeCashPositionWidget,
  financeBankAccountPositionWidget,
  financeBankAccountMovementWidget,
  salesUntaxedWidget,
  salesTaxAmountWidget,
  branchCashWidget,
  branchSalesWidget,
  branchPurchasesWidget,
  locationStorageCountWidget,
  locationEmployeeCountWidget,
  locationOnHandWidget,
  locationInventoryValueWidget,
  locationValueTrendWidget,
  locationMovementTrendWidget,
  locationStorageTypesWidget,
  storageBranchGrantsWidget,
  storageDetailsWidget,
  branchEmployeesWidget,
  branchRefundsWidget,
  branchTerminalsWidget,
  expensesTotalWidget,
  expensesClaimCountWidget,
  expensesReimbursableWidget,
  expensesSpendTrendWidget,
  expensesClaimTrendWidget,
  expensesStatusListWidget,
  expensesCategoryReportWidget,
  subscriptionsActiveWidget,
  subscriptionsRecurringRevenueWidget,
  subscriptionsRenewalsDueWidget,
  subscriptionsRevenueTrendWidget,
  subscriptionsRenewalTrendWidget,
  subscriptionsStatusListWidget,
  subscriptionsPerformanceReportWidget,
  posOrderCountWidget,
  posSalesWidget,
  posActiveSessionsWidget,
  posSalesTrendWidget,
  posPaymentTrendWidget,
  posStatusListWidget,
  posPaymentReportWidget,
  rentalOrderCountWidget,
  rentalValueWidget,
  rentalActiveWidget,
  rentalValueTrendWidget,
  rentalOrderTrendWidget,
  rentalStatusListWidget,
  rentalStatusReportWidget,
  salesPerformanceReportWidget,
] as const;

export const WIDGET_DEFINITIONS = WIDGET_CONFIGURATIONS.map(createWidgetDefinition);
export const LOCATION_WIDGET_DEFINITIONS = WIDGET_DEFINITIONS.filter(item => item.widgetId.startsWith('location.'));
export const ORGANISATION_WIDGET_DEFINITIONS = WIDGET_DEFINITIONS.filter(item => item.widgetId.startsWith('organisation.record.'));

export function widgetsForApp(appId: string) {
  return WIDGET_DEFINITIONS.filter(definition => definition.apps.includes(appId));
}
